import { makeStyles } from 'tss-react/mui'
import PageMetaData from '@v4/utils/data/PageMetaData'
import { TEXT_POSITION } from '../../CallToAction.const'

const useStyles = makeStyles()((theme, { mobileAlignment = null, mobileButtonWidth }, classes) => ({
	root: {
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
		maxWidth: theme.spacing(92),
		width: '100%',
	},
	[TEXT_POSITION.TOP]: {
		[`& .${classes.additionalText}`]: {
			marginBottom: theme.spacing(2),
		},
	},
	[TEXT_POSITION.BOTTOM]: {
		[`& .${classes.additionalText}`]: {
			marginTop: theme.spacing(3.2),
		},
	},
	additionalText: {
		textAlign: 'center',

		[theme.breakpoints.down('sm')]: {
			'& *': {
				textAlign: mobileAlignment && `${mobileAlignment} !important`,
			},
		},
	},
	image: {
		display: 'flex',
		justifyContent: 'center',
		height: theme.spacing(16),
		width: theme.spacing(16),
		marginBottom: theme.spacing(2),
		'& img': {
			height: '100%',
			objectPosition: 'center bottom',
			objectFit: 'contain',
		},
	},
	content: {
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
		width: '100%',

		[theme.breakpoints.down('sm')]: {
			alignItems: `${PageMetaData.CONTENT_ALIGNMENT[mobileAlignment]} !important`,
		},
	},
	text: {
		[theme.breakpoints.down('sm')]: {
			'& *': {
				textAlign: mobileAlignment && `${mobileAlignment} !important`,
			},
		},
	},

	buttonWrap: {
		width: '100%',
		display: 'flex',
		justifyContent: 'center',

		[theme.breakpoints.down('sm')]: {
			justifyContent: `${PageMetaData.CONTENT_ALIGNMENT[mobileAlignment]} !important`,
		},
	},

	button: {
		width: 'auto',
		marginBottom: theme.spacing(1.5),

		[theme.breakpoints.down('sm')]: {
			width: mobileButtonWidth,
		},
	},
}))

export default useStyles
